/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ToggleSSOInput = {|
  activateOkta?: ?boolean,
  activateOneLogin?: ?boolean,
  activateAAD?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ToggleSSOMutationVariables = {|
  input: ToggleSSOInput
|};
export type ToggleSSOMutationResponse = {|
  +toggleSSO: ?{|
    +company: ?{|
      +AADEnabled: ?boolean,
      +oktaEnabled: ?boolean,
      +oneloginEnabled: ?boolean,
      +scimUsernamePassword: ?string,
    |}
  |}
|};
export type ToggleSSOMutation = {|
  variables: ToggleSSOMutationVariables,
  response: ToggleSSOMutationResponse,
|};
*/


/*
mutation ToggleSSOMutation(
  $input: ToggleSSOInput!
) {
  toggleSSO(input: $input) {
    company {
      AADEnabled
      oktaEnabled
      oneloginEnabled
      scimUsernamePassword
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ToggleSSOInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "AADEnabled",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oktaEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneloginEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scimUsernamePassword",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleSSOMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleSSOPayload",
        "kind": "LinkedField",
        "name": "toggleSSO",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ToggleSSOMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleSSOMutation(\n  $input: ToggleSSOInput!\n) {\n  toggleSSO(input: $input) {\n    company {\n      AADEnabled\n      oktaEnabled\n      oneloginEnabled\n      scimUsernamePassword\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f1d5b0ba420c88ca0823213c20ed410c';

module.exports = node;
